import { LoaderActions, LoaderActionTypes } from '@app/core/actions/loader';
import { createHandler, createReducer } from '@app/util';
import * as R from 'ramda';


export interface State {
  isLoading: number;
}

export const initialState: State = {
  isLoading: 0
};

const showLoaderHandler = createHandler(LoaderActionTypes.ShowLoader, (state: State) =>
  R.mergeRight(state, {
    isLoading: state.isLoading + 1
  })
);

const hideLoaderHandler = createHandler(LoaderActionTypes.HideLoader, (state: State) =>
  R.mergeRight(state, {
    isLoading: state.isLoading > 0 ? state.isLoading - 1 : 0
  })
);

export const reducer = createReducer<State, LoaderActions>([
  showLoaderHandler,
  hideLoaderHandler
], initialState);

export const getIsLoading = (state: State) => state.isLoading > 0;
